import { render } from "./Stages.vue?vue&type=template&id=4b0b9ef1&scoped=true&ts=true&lang=pug"
import script from "./Stages.vue?vue&type=script&lang=ts&setup=true"
export * from "./Stages.vue?vue&type=script&lang=ts&setup=true"

import "./Stages.vue?vue&type=style&index=0&id=4b0b9ef1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0b9ef1"]])

export default __exports__